export interface WaterFactoryModel {
    name: string;
    code: string;
    address: string;
    image: string;
    description: string;
    latitude: number;
    longtitude: number;
    id: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;
    status: string;
}

export class WaterFactoryModelFactory {
    static getEmpty(): WaterFactoryModel {
        return {
            name: "",
            code: "",
            address: "",
            image: "",
            description: "",
            latitude: 0,
            longtitude: 0,
            id: "",
            createdAt: undefined,
            updatedAt: undefined,
            createdBy: undefined,
            updatedBy: undefined,
            status: ""
        };
    }
}
